import React, { useContext } from "react";
import { AuthContext } from "../../AuthProvider"; 
import { LoadingPopup } from "../../components/LoadingPopup/LoadingPopup";
import sendLogError from "../../sendLogError";
import { mockUserData } from "../../mocks/fakeAuth";

const ContextConstructor = React.createContext();

export default ContextConstructor;


export class ContextProvider extends React.Component {
  static contextType = AuthContext; 

  constructor(props) {
	super(props);

	this.state = {
	  mymUsers: [],
	  selectedUser: [],
	  selectedUserID: "",
	  tokenUser: "",
	  userName: "",
	  parentUser: {},
	  idToken: "", 
	  msalInstance: null,
	  isLoggedIn: false,
	  loading: true,
	  // Election dates state
	  isElectionsTime: false,
	  electionDates: null,
	};
  }

	componentDidMount() {
		const { idToken, isLoggedIn, msalInstance } = this.context;

		this.setState({
			idToken,
			isLoggedIn,
			msalInstance,
		});
	}

	componentDidUpdate(prevProps, prevState) {
		const { idToken } = this.context;
		const isFakeAuth = process.env.REACT_APP_FAKE_AUTH === "true";

		if (idToken && prevState.idToken !== idToken) {
			this.setState(
				{
					idToken,
					isLoggedIn: this.context.isLoggedIn,
					msalInstance: this.context.msalInstance,
				},
				() => {
					if (isFakeAuth) {
						mockUserData(this.setState.bind(this));
					} else {
						this.populateAssociateData();
					}
					this.fetchElectionDates();
				}
			);
		}
	}

	fetchElectionDates = async () => {
		try {
			const { idToken } = this.state;
			if (!idToken) return;

			const headers = {
				Authorization: `Bearer ${idToken}`
			};

			const response = await fetch("/Elections/GetElectionDates", { headers });

			if (!response.ok) {
				throw new Error(`Erro HTTP: ${response.status}`);
			}

			const data = await response.json();

			// validação defensiva
			if (!data?.actualDate || !data?.endDate) {
				throw new Error("Dados inválidos na resposta");
			}

			const currentDate = new Date(data.actualDate);
			const endDate = new Date(data.endDate);

			const isElectionsTime = currentDate < endDate;

			this.setState({
				isElectionsTime,
				electionDates: data,
			});

		} catch (error) {
			console.error("Error fetching election dates:", error);

			this.setState({
				isElectionsTime: false,
				electionDates: null,
			});

			sendLogError(error.message, "fetchElectionDates");
		}
	};

	contextInit = (usersProfile, selectedUserIDClientID, isActualUser, selectedUserProfile) => {
		// console.log("selectedUserProfile ", selectedUserProfile);

		this.setState({
		mymUsers: usersProfile,
		selectedUser: selectedUserProfile,
		selectedUserID: selectedUserIDClientID,
		tokenUser: isActualUser,
		parentUser: selectedUserProfile,
		loading: false, 
		});
	};

	handleLogout = async () => {
		const { msalInstance, redirectUri, idToken} = this.state;
		if (!msalInstance) return;

		try {
			await msalInstance.logoutRedirect({
			postLogoutRedirectUri: "https://www.montepio.org",
			idTokenHint: idToken
			});
		} catch (error) {
			console.error("Error during logout:", error);
		}
	};

	changeselectedUserID = (associate) => {
		this.setState({
		selectedUserID: associate.clientID,
		selectedUser: associate,
		});
	};

	populateAssociateData = async () => {
		try {
			const { idToken } = this.state;
			if (!idToken) return;

			const headers = {
				Authorization: `Bearer ${idToken}`,
			};

			// Buscar associados
			const resAssociates = await fetch("/Profile/GetMymAssociates", { headers });

			if (!resAssociates.ok) {
				throw new Error(`Erro ao obter associados: ${resAssociates.status}`);
			}
			
			const data = await resAssociates.json();

			let parsed = [];

			try {
				parsed = data?.value ? JSON.parse(data.value) : [];
			} catch (e) {
				console.error("Erro a fazer parse de associados", e);
				parsed = [];
			}

			const associates = Array.isArray(parsed) ? parsed : [];

			// Buscar perfil do utilizador
			const resProfile = await fetch("/Profile/GetProfile", { headers });

			if (!resProfile.ok) {
				throw new Error(`Erro ao obter perfil: ${resProfile.status}`);
			}

			const userProfileResponse = await resProfile.json();
			
			const isValidProfile = userProfileResponse 
				&& Object.keys(userProfileResponse).length > 0 
				&& userProfileResponse.clientID;
				
			let selectedUserClientID = "";
			let finalAssociates = associates;

			if (isValidProfile) {
				finalAssociates = [...associates, userProfileResponse];
				
				finalAssociates = finalAssociates.map((associated) => {
					const isTokenUser = associated.clientID === userProfileResponse.clientID;

					if (isTokenUser) {
						selectedUserClientID = associated.clientID;
					}

					return {
						...associated,
						isTokenUser,
					};
				});			
			}			

			// Atualizar contexto
			this.contextInit(
				finalAssociates,
				selectedUserClientID,
				userProfileResponse?.clientID,
				userProfileResponse
			);

			this.setState({ loading: false });
		} catch (error) {
			console.error("Error in populateAssociateData:", error);
			
			this.setState({ loading: false });
			
			sendLogError(error.message, "populateAssociateData");
		}
	};

  render() {
	// console.log("main context ", this.state);
	const {
	  mymUsers,
	  selectedUser,
	  selectedUserID,
	  tokenUser,
	  parentUser,
	  idToken,
	  isLoggedIn,
	  msalInstance,
	  loading,
	  isElectionsTime,
	  electionDates,
	} = this.state;
	
	const { contextInit, changeselectedUserID, handleLogout } = this;

	if (loading) {
		return (
			<LoadingPopup/>
		);
	}
	  
	return (
	  <ContextConstructor.Provider
		value={{
		  mymUsers,
		  selectedUser,
		  selectedUserID,
		  tokenUser,
		  contextInit,
		  changeselectedUserID,
		  parentUser,
		  idToken,
		  isLoggedIn,
		  msalInstance,
		  handleLogout,
		  isElectionsTime,
		  electionDates,
		}}>
		{this.props.children}
	  </ContextConstructor.Provider>
	);
  }
}
